var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7227 3.7937C11.0655 3.7937 11.3434 4.07156 11.3434 4.41433V9.37933H16.3084C16.6511 9.37933 16.929 9.65719 16.929 9.99995C16.929 10.3427 16.6511 10.6206 16.3084 10.6206H11.3434V15.5856C11.3434 15.9283 11.0655 16.2062 10.7227 16.2062C10.38 16.2062 10.1021 15.9283 10.1021 15.5856V10.6206H5.1371C4.79434 10.6206 4.51648 10.3427 4.51648 9.99995C4.51648 9.65719 4.79434 9.37933 5.1371 9.37933H10.1021V4.41433C10.1021 4.07156 10.38 3.7937 10.7227 3.7937Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateTask);
export default __webpack_public_path__ + "static/media/CreateTask.2b134c8131089761c501594fb098d5ae.svg";
export { ForwardRef as ReactComponent };